import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import { useNavigate } from 'react-router-dom';

export type RemovePlanFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: RemovePlanFormProps) => {
  const navigate = useNavigate();
  const [
    fnRemovePlanForm,
    { loading }
  ] = ds.useRemovePlan();

  const handleSubmit = async (id: string) => {

    await fnRemovePlanForm({
      id
    });
    navigate('..');

    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit(props.id);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <></>
    </FormBaseLayout.FC>

  );
};
